// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__eABvm","savePackageButton":"ClientWallet_savePackageButton__dstyh"};